


























































import * as moment from "moment";
import { OffersTypes, Vue } from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("dyn-offers-card", {
  props: ["data", "showOffers"],
  data() {
    return {
      staticContent,
    };
  },

  computed: {
    type() {
      switch (this.data.offerType) {
        case OffersTypes.Company:
          return {
            icon: "#business-suitcase",
            labelClass: "dynamic-card__label--business",
            text: staticContent.common.businessLabel,
            offerClass: "offer-text--business",
          };
        default:
          return null;
      }
    },
  },
});
